const derived = {
  getValidationErrors: (props, moment, _) => {
    const errors = {
      required: undefined,
      minMax: undefined,
      customRule: undefined,
      email: undefined,
      number: undefined,
      url: undefined,
    };
    const text = props.text ?? "";
    if (props.isRequired && (!text || !text.length)) {
      errors.required = "Required";
    }

    if (
      props.customValidationRule &&
      props.customValidationRule.length &&
      props.customValidationRule === "false"
    ) {
      errors.customRule = props.customErrorMessage || "Invalid";
    }

    if (props.inputType === "TEXT" || props.inputType === "PASSWORD") {
      const maxLengthNum =
        props.maxLength && props.maxLength > 0 ? props.maxLength : 0;
      const minLengthNum =
        props.minLength && props.minLength > 0 ? props.minLength : 0;
      if (maxLengthNum !== 0 && minLengthNum !== 0) {
        if (text.length > maxLengthNum || text.length < minLengthNum) {
          errors.minMax =
            "Value must be between " +
            minLengthNum +
            " and " +
            maxLengthNum +
            " chars. long";
        }
        if (maxLengthNum <= minLengthNum) {
          errors.minMax = "Invalid min/max length setup";
        }
      }
      if (
        minLengthNum === 0 &&
        maxLengthNum > 0 &&
        text.length > maxLengthNum
      ) {
        errors.minMax =
          "Value must be less than " + maxLengthNum + " chars. long";
      }
      if (
        maxLengthNum === 0 &&
        minLengthNum > 0 &&
        text.length < minLengthNum
      ) {
        errors.minMax =
          "Value must be more than " + minLengthNum + " chars. long";
      }
    }

    if (props.inputType === "EMAIL") {
      const emailRegex =
        props.emailRegex ??
        /(([^<>()[\\].,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})/;
      const hasValue = text && text.length; // text is sometimes undefined, and sometimes ""
      if (hasValue && !emailRegex.test(text)) {
        errors.email = "Must be a valid email address";
      }
    }

    if (props.inputType === "NUMBER") {
      const hasValue = text && text.length; // text is sometimes undefined, and sometimes ""
      if (hasValue && Number.isNaN(Number(text))) {
        errors.number = "Must be a valid number";
      }
    }

    if (props.inputType === "URL") {
      try {
        text && new URL(text);
      } catch (e) {
        errors.url = "Must be a valid URL";
      }
    }

    return errors;
  },
  //
  getValue: (props, moment, _) => {
    if (props.inputType === "NUMBER") {
      return Number.isNaN(Number(props.text)) || !props.text
        ? null
        : parseFloat(props.text);
    }
    if (props.inputType === "EMAIL") {
      const emailRegex =
        props.emailRegex ??
        /(([^<>()[\\].,;:\\s@\\"]+(\\.[^<>()[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})/;
      if (emailRegex.test(props.text)) {
        return props.text;
      }
      if (
        props.defaultText &&
        props.defaultText.length &&
        emailRegex.test(props.defaultText)
      ) {
        return props.defaultText;
      }
      return null;
    }
    return props.text ?? "";
  },
  //
};

export default derived;
